const whitelabelThemeMapping = {
    gray50: ["--rc-gray-50"],
    gray500: ["--rc-gray-500"],
    gray700: ["--rc-gray-700"],
    gray900: ["--rc-gray-900"],
    primary: ["--rc-primary"],
    primary50: ["--primary-50"],
    primary500: ["--primary-500"],
    primary800: ["--primary-800"],
    orange: ["--rc-orange"],
    danger500: ["--rc-danger-500"],
    success500: ["--rc-success-500"],
    uiBorderColor: ["--uiborder-color"],
    bgColor: ["--rc-bg-color"],
    primaryColor: ["--p-primary-color"],
}

export function injectWhitelabelStyles(config: Record<string, string> | null): void {
    const styleId = 'whitelabelStyle';
    let styleElement = document.getElementById(styleId) as HTMLStyleElement | null;

    if (config == null) {
      // Config null, then remove styleElement
      if (styleElement) {
          styleElement.remove();
      }
      return;
    }
    
    const themeVariables = Object.entries(whitelabelThemeMapping)
    .filter(([key]) => {
      const value = config[key];
      return typeof value === 'string' && value.trim() !== '';
    })
    .flatMap(([key, cssVars]) =>
      cssVars.map(cssVar => `${cssVar}: ${config[key]};`)
    )
    .join('\n  ');

    const cssString = `:root {\n  ${themeVariables}\n}`;

    if (!styleElement) {
      styleElement = document.createElement('style');
      styleElement.id = styleId;
      document.head.appendChild(styleElement);
    }

    styleElement.innerHTML = cssString;
}